var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56899 2.69796L3.4485 6.68795C2.5935 7.35295 1.9 8.76845 1.9 9.84195V16.8814C1.9 19.0854 3.69549 20.8904 5.89949 20.8904H16.9005C19.1045 20.8904 20.9 19.0854 20.9 16.8909V9.97495C20.9 8.82545 20.1305 7.35295 19.19 6.69745L13.319 2.58396C11.989 1.65296 9.85149 1.70046 8.56899 2.69796Z",
    stroke: "white",
    strokeWidth: 1.425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 17.0902V14.2402",
    stroke: "white",
    strokeWidth: 1.425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanel);
export default __webpack_public_path__ + "static/media/panel.ed558e18699c7891978e35bd52e61831.svg";
export { ForwardRef as ReactComponent };